import React from "react";
import Template from "../components/Template";
import BreadCrumb from "../components/BreadCrumb";
import Testimonials from "../components/Testimonials";
import { Link } from "react-router-dom";

function About() {
  return (
    <Template>
      <BreadCrumb pageName="About Us" />

      {/* About Start */}
      <section className="section-lgx">
        <div className="container">
          <div className="row g-0">
            <div className="col-lg-6" style={{ padding: "20px" }}>
              <img
                src="assets/images/daily/v1 (4).png"
                className="img-fluid"
                alt=""
              />
            </div>

            <div className="col-lg-6">
              <div className="pbmit-heading-subheading animation-style1">
                <h4 className="pbmit-subtitle">
                  <span></span>Know About Us
                </h4>
                <h2 className="pbmit-title">DISCOVER YOUR PERFECT FIT</h2>
              </div>

              <p>
                Coach Elite is a body first performance system for people who
                want clarity, consistency, and better decisions without burnout.
              </p>

              <p>
                We begin by building physical capacity to regulate energy and
                focus, then apply structured performance coaching to design
                daily routines, sharpen execution, and improve decision making
                under pressure.
              </p>
              <p>
                Whether you’re starting with fitness or developing a performance
                plan to grow your career, Coach Elite supports professionals and
                high performing individuals with coaching that sustains
                progress, leadership, and long term success.
              </p>
              {/* 
              <a href="our-classes.html" className="pbmit-btn pbmit-btn-white">
                <span className="button-text">Read More</span>
              </a> */}
            </div>
          </div>
        </div>
      </section>
      {/* About End */}

      <hr />

      {/* Ihbox Start */}
      <section className="ihbox-section-one">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="pbmit-heading-subheading animation-style1 text-center">
                <h4 className="pbmit-subtitle">
                  <span></span>Unlock Your Full Potential
                </h4>
                <h2 className="pbmit-title">Choose Your Path</h2>
              </div>
            </div>
            <div className="col-md-6">
              <div className="pbmit-ihbox pbmit-ihbox-style-7">
                <div className="pbmit-ihbox-box">
                  <div className="pbmit-ihbox-headingicon">
                    <div className="pbmit-ihbox-contents">
                      <h2 className="pbmit-element-title">
                        Path 1: Performance &amp; Leadership Coaching
                      </h2>
                      <div className="pbmit-heading-desc">
                        <p>
                          Designed for professionals and leaders who want mental
                          clarity, disciplined execution, and sustainable energy
                          to perform at their best without burnout.
                        </p>

                        <ul>
                          <li>
                            • Personalized performance routines integrating
                            fitness, mindfulness, and goal strategy
                          </li>
                          <li>
                            • Nutrition and lifestyle coaching to support
                            sustained focus, resilience, and recovery
                          </li>
                          <li>
                            • Structured systems for leadership growth and
                            consistent high performance
                          </li>
                        </ul>
                        <br />

                        <p>
                          If you want to master your habits, decision making,
                          and leadership impact under pressure, this is your
                          path.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="pbmit-ihbox pbmit-ihbox-style-7">
                <div className="pbmit-ihbox-box">
                  <div className="pbmit-ihbox-headingicon">
                    <div className="pbmit-ihbox-contents">
                      <h2 className="pbmit-element-title">
                        Path 2: Fitness-Focused Coaching
                      </h2>
                      <div className="pbmit-heading-desc">
                        <p>
                          Built for individuals committed to fitness who want
                          more than workouts seeking physical capacity, energy,
                          and mental resilience that supports success in every
                          area of life.
                        </p>

                        <ul>
                          <li>
                            • Custom workouts and yoga to build strength,
                            mobility, and recovery
                          </li>
                          <li>
                            • Simple, habit based nutrition to fuel energy and
                            consistency
                          </li>
                          <li>
                            • Lifestyle support for stress management, movement
                            quality, and daily discipline
                          </li>
                        </ul>

                        <br />

                        <p>
                          If you want fitness that powers your life and career,
                          this is your path.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="pbmit-ihbox pbmit-ihbox-style-7">
                <div className="pbmit-ihbox-box">
                  <div className="pbmit-ihbox-headingicon">
                    <div className="pbmit-ihbox-contents">
                      <br />
                      <br />
                      <h2 className="pbmit-element-title text-center">
                        How We Work With You
                      </h2>
                      <div className="pbmit-heading-desc text-center">
                        <p>
                          All coaching is personalized and performance driven.
                          We blend physical training, nutrition, lifestyle
                          design, and mindset work to match your goals. Choose
                          one path or combine both for maximum, sustainable
                          impact.
                        </p>

                        <p>
                          <strong>Ready to Get Started?</strong>
                          <br />
                          <br />
                          <strong>
                            <Link to="/clarity-call">
                              👉 Book a Free Clarity Call
                            </Link>
                          </strong>{" "}
                          to explore which path fits your goals and how Coach
                          Elite can help you perform at your highest level.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Ihbox End */}

      {/* Testimonial Start */}
      <section className="section-lgx pb-0">
        <Testimonials />
      </section>

      <hr />

      {/* About Start */}
      <section className="section-lgx">
        <div className="container">
          <div className="row g-0 justify-content-center">
            <div className="col-lg-8 text-center">
              <p>
                <b>
                  DailyFitZone is a fitness and wellness brand focused on
                  helping individuals build strength, energy, and consistency.
                </b>
              </p>

              <p>
                <b>
                  The brand DailyFitZone is owned and operated by CoachElite, a
                  registered fitness and coaching company.
                </b>
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* About End */}
    </Template>
  );
}

export default About;
